import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import {
  convertDateFormate,
  getDateByNameV1,
} from "../../helpers/api_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import Loader from "../../Components/Common/Loader";

const LocationChartRevenue = ({
  leftFilter,
  mealPeriod,
  widgetDetailGroupId
}) => {
const [loading, setLoading] = useState(false);
const [series, setSeries] = useState([]);
const [customLabels, setCustomLabels] = useState([]);

// Convert date range helper
// const convertDateRange = (filter, customDate) =>
//   filter === "Custom"
//     ? {
//         from: convertDateFormate(customDate[0]),
//         to: convertDateFormate(customDate[1]),
//         from_date: convertDateFormate(customDate[0]),
//         to_date: convertDateFormate(customDate[1]),
//       }
//     : getDateByNameV1(filter);

  useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
  
        //const leftFilterDate = convertDateRange(leftFilter.value, leftCustomDate);
  
        const payload = {
          serviceName: "kpi_data",
          op: "flash_kpi_forecast",
          group_id: widgetDetailGroupId,
          leftFilter: leftFilter,
          mealPeriod: mealPeriod,
        };
  
        const response = await postDataAPI(payload);
        const res = {
          revenueThisYear: [],
          revenueLastYear: [],
          tableOccThisYear: [],
          tableOccLastYear: [],
          seatOccThisYear: [],
          seatOccLastYear: [],
        };
  
        if (response.status === "ok") {
          const results = response.data.data || {};
          res.revenueThisYear = results.revenue || [];
          res.revenueLastYear = results.revenue_lastyear || [];
          res.tableOccThisYear = results.table_occupancy || [];
          res.tableOccLastYear = results.table_occupancy_lastyear || [];
          res.seatOccThisYear = results.seat_occupancy || [];
          res.seatOccLastYear = results.seat_occupancy_lastyear || [];
  
  
          // Create date labels for X-axis
          const startDate = new Date(results.start_dt);
          const labels = [];
          if(results?.revenue) {
            const totalDays = results.covers.length; // assumes `covers` is defined and is an array
    
            let currentDate = new Date(startDate);
    
            for (let i = 0; i < totalDays; i++) {
              const day = currentDate.toLocaleString("en-us", { day: "2-digit" });
              const month = currentDate.toLocaleString("en-us", { month: "short" });
              labels.push(`${day}-${month}`);
              currentDate.setDate(currentDate.getDate() + 1);
            }
          }
          setCustomLabels(labels);
        }
  
        setSeries([
          {
            name: "Revenue (This Year)",
            type: "column",
            data: res.revenueThisYear,
          },
          {
            name: "Revenue (Last Year)",
            type: "column",
            data: res.revenueLastYear,
          },
          {
            name: "Table Occ (This Year)",
            type: "line",
            data: res.tableOccThisYear,
          },
          {
            name: "Table Occ (Last Year)",
            type: "line",
            data: res.tableOccLastYear,
          },
          {
            name: "Seat Occ (This Year)",
            type: "line",
            data: res.seatOccThisYear,
          },
          {
            name: "Seat Occ (Last Year)",
            type: "line",
            data: res.seatOccLastYear,
          },
        ]);
  
        setLoading(false);
      };
  
      fetchData();
    }, [leftFilter, mealPeriod, widgetDetailGroupId]);

  const options = {
    chart: {
      stacked: false,
      toolbar: { show: false }
    },
    stroke: {
      width: [0, 0, 2, 2, 2, 2],
      curve: "smooth"
    },
    xaxis: {
      categories: customLabels
    },
    dataLabels: {
      enabled: false
    },
    markers: {
      size: 4, // Show small circles on line points
    },
    colors: [
      "#007bff", // Revenue (This Year)
      "#6f42c1", // Revenue (Last Year)
      "#dc3545", // Table Occ (This Year)
      "#fd7e14", // Table Occ (Last Year)
      "#20c997", // Seat Occ (This Year)
      "#198754"  // Seat Occ (Last Year)
    ],
    yaxis: [
      {
        seriesName: "Revenue (This Year)",
        title: { text: "Revenue" },
        min: 0,
        tickAmount: 4,
        labels: {
          formatter: function (val) {
            return typeof val === 'number' ? val.toFixed(0) : '0';
          }
        }
      },
      {
        show: false
      },
      {
        opposite: true,
        title: { text: "Occupancy" },
        min: 0,
        tickAmount: 5,
        labels: {
          formatter: function (val) {
            return typeof val === 'number' ? val.toFixed(0) : '0';
          }
        }
      }
    ],
    // tooltip: {
    //   shared: true,
    //   // intersect: false,
    //   // followCursor: true,
    //   // y: {
    //   //   formatter: function (value, { seriesIndex }) {
    //   //     if (value == null || isNaN(value)) return '-';
    //   //     return [0, 1].includes(seriesIndex) ? value.toFixed(0) : value.toFixed(2);
    //   //   }
    //   // }
    // },
    legend: {
      position: "bottom",
      horizontalAlign: "center"
    }
  };

  return (
    <>
      {loading && <Loader />}    
      <div className={loading ? "opacity-0" : ""}>
        <ReactApexChart options={options} series={series} type="line" height={400} />
      </div>
    </>
    
  );
};

export default LocationChartRevenue;
